import { useColorScheme as useColorSchemeMui } from '@mui/joy/styles';

export type ColorSchemeMode = 'light' | 'dark';

export interface ColorScheme {
  mode: ColorSchemeMode | undefined;
  isDarkMode: boolean;
  isLightMode: boolean;
}

export function useColorScheme(): ColorScheme {
  const { systemMode, mode } = useColorSchemeMui();
  const mergedMode = mode === 'system' ? systemMode : mode;
  const isDarkMode = mergedMode === 'dark';

  return {
    mode: mergedMode,
    isDarkMode,
    isLightMode: !isDarkMode,
  };
}
